var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResumeSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 99,
    viewBox: "0 0 99 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.1129 92.922C66.2876 92.922 66.2876 97.75 63.1129 97.75H4.94371C3.61071 97.75 2.53027 96.6684 2.53027 95.3354V22.6412C2.53027 21.9747 2.80038 21.3702 3.23653 20.934L22.2143 1.95743C22.6855 1.4862 23.3029 1.25 23.9203 1.25H78.5138C79.8468 1.25 80.9284 2.3316 80.9284 3.66461V45.9184C80.9284 49.0943 76.1003 49.0943 76.1003 45.9184V6.07804H24.92L7.35832 23.6409V92.922H63.1129ZM22.0459 39.5247C18.8701 39.5247 18.8701 34.6967 22.0459 34.6967H57.9048C61.0807 34.6967 61.0807 39.5247 57.9048 39.5247H22.0459ZM22.0459 50.2308C18.8701 50.2308 18.8701 45.4028 22.0459 45.4028H57.9048C61.0807 45.4028 61.0807 50.2308 57.9048 50.2308H22.0459ZM22.0459 60.9369C18.8701 60.9369 18.8701 56.1089 22.0459 56.1089H57.9048C61.0807 56.1089 61.0807 60.9369 57.9048 60.9369H22.0459ZM22.0459 28.8186C18.8701 28.8186 18.8701 23.9906 22.0459 23.9906H57.9048C61.0807 23.9906 61.0807 28.8186 57.9048 28.8186H22.0459Z",
    fill: "#AAAAAA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96 63.7258L92.2742 60L76.3548 75.9133L69.7258 69.2903L66 73.0161L76.3548 83.371L96 63.7258Z",
    fill: "#00E45B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResumeSelected);
export default __webpack_public_path__ + "static/media/resume_selected.93786755d3f5b9b48a0d3a2c6a48bd82.svg";
export { ForwardRef as ReactComponent };